import { VerticalGauge } from './VerticalGauge/index'
import { ThumborImg } from 'lib/images/ThumborImage'
import { Provider, SummaryLevelEnum } from 'generated/api'
import { Color, FlexBox, FlexItem } from 'components/styles'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import type { ColorRanges } from 'components/styles/primitives/modifiers/color/types'
import { colors } from 'parameters/ui'
import { PendingFC } from 'components/patterns/suspense/componentWrappers'
import { css } from '@emotion/react'
import { ApprovabilitySummaryLevelMap } from '../constants'
import { SpaceMultiple } from 'components/styles/definitions/size/typographyScale'

const ApprovabilityColorRanges = Object.entries(ApprovabilitySummaryLevelMap).reduce<ColorRanges<number>>(
	(prev, [, value]) => ({ ...prev, [value.percentage]: value.color }),
	{}
)

interface Props {
	value?: SummaryLevelEnum
	provider: Provider
}

export const GridItem: PendingFC<Props> = props => {
	let gauge
	let filter = 'grayscale(0)'
	if (props.pending || props.value === undefined) {
		filter = 'grayscale(1)'
		gauge = <VerticalGauge colorRange={{ 0: new Color(colors.primaryLightGrey1) }} value={0} />
	} else {
		const { value } = props
		const percentage = ApprovabilitySummaryLevelMap[value].percentage
		gauge = <VerticalGauge colorRange={ApprovabilityColorRanges} value={percentage} />
	}

	const image =
		(props.provider?.imageUrl?.length ?? 0) > 0 ? (
			<FlexItem alignSelf="center" modifiers={TextMods.Centered}>
				<ThumborImg
					src={props.provider?.imageUrl || ''}
					alt={`${props.provider?.name} logo`}
					modifiers={[
						css({
							objectFit: 'contain',
							objectPosition: '50% 50%',
							maxHeight: '3.5rem',
							maxWidth: '80%',
							transition: 'filter 1s linear',
							filter
						})
					]}
					options={{ height: 50 }}
				/>
			</FlexItem>
		) : (
			<FlexItem alignSelf="center" modifiers={TextMods.Centered} />
		)

	return (
		<FlexBox
			height={SpaceMultiple(5)}
			space="small"
			alignItems="space-evenly"
			justifyContent="center"
			border="thin"
			borderColor={colors.primaryLightGrey1}
			corners="round"
		>
			{image}
			{gauge}
		</FlexBox>
	)
}
